<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>运营用户访问sdk</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/us/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "stable",
          linkList: [ur + "zto-us.min.js"]
        },
        {
          label: "beta",
          linkList: [ur + "zto-us.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListUs.vue